$(document).ready(function() {
  $(window).scroll(function() {
    if ($(document).scrollTop() > 100) {
      $('html').addClass('scrolled');
    } else {
      $('html').removeClass('scrolled');
    }
  });

  if ($(document).scrollTop() > 100) {
    $('html').addClass('scrolled');
  } else {
    $('html').removeClass('scrolled');
  }
});

if(!$('.module--page-header').length){
  $('html').addClass('no-page-header');
}

// Toggle menu
$(document).on('click', '.menu-toggle', function() {
  $('html').toggleClass('open-menu');
});

// Close menu when clicked on menu link
$(document).on('click', '.page-menu nav ul.primary-nav li a', function() {
  $('html').removeClass('open-menu');
});

// close menu when resize window
$( window ).resize(function() {
  $('html').removeClass('open-menu');
});
